/**
 * Utility function to create a delay
 * @param {number} ms - Delay duration in milliseconds (default: 50ms)
 * @returns {Promise<void>}
 */
export const delay = (ms = 50) => new Promise(resolve => setTimeout(resolve, ms));
